export let ArchiveMalware = /*#__PURE__*/function (ArchiveMalware) {
  ArchiveMalware["NONE"] = "NONE";
  ArchiveMalware["WITH_PREMIUM_MALWARE_AND_ENCRYPT"] = "WITH_PREMIUM_MALWARE_AND_ENCRYPT";
  ArchiveMalware["WITH_PREMIUM_MALWARE"] = "WITH_PREMIUM_MALWARE";
  ArchiveMalware["WITH_FREE_MALWARE_AND_ENCRYPT"] = "WITH_FREE_MALWARE_AND_ENCRYPT";
  ArchiveMalware["WITH_FREE_MALWARE"] = "WITH_FREE_MALWARE";
  return ArchiveMalware;
}({});
export let ArchiveReceptionChannel = /*#__PURE__*/function (ArchiveReceptionChannel) {
  ArchiveReceptionChannel["ALL"] = "TODOS";
  ArchiveReceptionChannel["WEB_SERVICE"] = "WEB_SERVICE";
  ArchiveReceptionChannel["ORDINARY_MAIL"] = "CORREO_ORDINARIO";
  ArchiveReceptionChannel["EMAIL"] = "CORREO_ELECTRONICO";
  ArchiveReceptionChannel["CERTIFIED_MAIL"] = "CORREO_CERTIFICADO";
  ArchiveReceptionChannel["FACE_TO_FACE"] = "PRESENCIAL";
  ArchiveReceptionChannel["BUROFAX"] = "BUROFAX";
  ArchiveReceptionChannel["SUITCASE"] = "VALIJA";
  ArchiveReceptionChannel["FAX"] = "FAX";
  ArchiveReceptionChannel["PLATFORM"] = "PLATAFORMA";
  ArchiveReceptionChannel["WEB_PORTAL"] = "PORTALWEB";
  ArchiveReceptionChannel["GENERATED"] = "GENERATED";
  return ArchiveReceptionChannel;
}({});
export let ArchiveStatus = /*#__PURE__*/function (ArchiveStatus) {
  ArchiveStatus[ArchiveStatus["NEW"] = 1] = "NEW";
  ArchiveStatus[ArchiveStatus["AIS_ANALYZE"] = 2] = "AIS_ANALYZE";
  ArchiveStatus[ArchiveStatus["AIS_PROCESSING"] = 3] = "AIS_PROCESSING";
  ArchiveStatus[ArchiveStatus["AIS_PROCESSED"] = 4] = "AIS_PROCESSED";
  ArchiveStatus[ArchiveStatus["UNDER_PREPARATION"] = 5] = "UNDER_PREPARATION";
  ArchiveStatus[ArchiveStatus["CLASSIFY_PROCESSING"] = 6] = "CLASSIFY_PROCESSING";
  ArchiveStatus[ArchiveStatus["CLASSIFY_PROCESSED"] = 7] = "CLASSIFY_PROCESSED";
  ArchiveStatus[ArchiveStatus["OCR_PROCESSING"] = 8] = "OCR_PROCESSING";
  ArchiveStatus[ArchiveStatus["OCR_PROCESSED"] = 9] = "OCR_PROCESSED";
  ArchiveStatus[ArchiveStatus["ERROR_PROCESS"] = 10] = "ERROR_PROCESS";
  ArchiveStatus[ArchiveStatus["INVALID"] = 11] = "INVALID";
  return ArchiveStatus;
}({});
export let ArchiveChecksumType = /*#__PURE__*/function (ArchiveChecksumType) {
  ArchiveChecksumType["MD5"] = "MD5";
  ArchiveChecksumType["SHA256"] = "SHA256";
  return ArchiveChecksumType;
}({});